export type ReaderType =
  | "TruckReader"
  | "PortableReader"
  | "DesktopReader"
  | "PortableReaderConnect"
  | "FivePortReaderConnect"
  | "Unknown";

export const readerTypes: { title: string; key: ReaderType }[] = [
  {
    title: "Truck reader",
    key: "TruckReader",
  },
  {
    title: "Portable reader",
    key: "PortableReader",
  },
  {
    title: "Desktop reader",
    key: "DesktopReader",
  },
  {
    title: "Portable reader connect",
    key: "PortableReaderConnect",
  },
  {
    title: "5-port reader connect",
    key: "FivePortReaderConnect",
  },
  {
    title: "Unknown",
    key: "Unknown",
  },
];

export enum DeviceConst {
  Details = "details",
  History = "history",
  Failed = "failed",
  Completed = "completed",
  OutStanding = "outstanding",
}
